import { Center, Loading } from '@cotera/client/app/components/ui';
import { Tab, useTabParams } from '../tab-manager';
import { TabItem } from '../components/topbar/tab-item';
import React, { Suspense } from 'react';
import { useDefinition } from '@cotera/client/app/etc/data/manifest';
import { NotFound } from '@cotera/client/app/components/app';
import { Relation } from '@cotera/era';
import { ResultBoundary } from '@cotera/client/app/components/boundaries';
import { useInScopeModel } from '../actions/framework';
import { GraphModel } from '../graph/graph.model';
import { GraphDataGrid } from '../data-grid';

export const DefinitionsPage: React.FC = () => {
  const { tabId, id: definitionId } = useTabParams<{
    tabId: string;
    id: string;
  }>();
  return (
    <>
      <Tab tabId={tabId}>
        <TabItem
          tab={{
            id: tabId,
            title: `definition/${definitionId}`,
            showClose: true,
          }}
        />
      </Tab>
      <Page />
    </>
  );
};

const Page: React.FC = () => {
  return (
    <div className="flex flex-col gap-4 h-full">
      <DefinitionView />
    </div>
  );
};

const DefinitionView: React.FC = () => {
  const { id: definitionId } = useTabParams<{ id: string }>();

  return (
    <Suspense
      fallback={
        <Center>
          <Loading.Dots />
        </Center>
      }
    >
      <ExploreDataSetView id={definitionId} />
    </Suspense>
  );
};

const ExploreDataSetView: React.FC<{ id: string }> = ({ id }) => {
  const { data: def } = useDefinition({ id });
  const graph = useInScopeModel(GraphModel);

  return (
    <ResultBoundary
      result={def}
      fallback={() => <NotFound resource={`Definition "${id}"`} />}
    >
      {(def) => (
        <div className="py-4 flex flex-col gap-4 h-full w-full">
          <GraphDataGrid
            relName={id}
            rel={Relation.wrap(def)}
            shouldShow={true}
            buildExplorer={() => graph.graph.snapshot()}
          />
        </div>
      )}
    </ResultBoundary>
  );
};
